import { actionConfirmation, actionWaiting, applyFilters, changePage, globalActionProgress, globalActionWaiting, refreshing, resetFilters, sortColumn } from "../actions";
import { SortingDirection } from "../../types";
import { loadFromLS, objectToParamFilter } from "../../utils";
import { DEFAULT_PAGE_SIZES } from "../../components/KPTable";
export function extractGetParamsFromState(state, tableId, defaultInitialPageSize) {
    if (state.kptable[tableId]) {
        const { sortingField, sortingDirection, top, skip, filter } = state.kptable[tableId];
        return {
            top,
            skip: skip * top,
            sort: sortingField,
            direction: sortingDirection,
            filter: objectToParamFilter(filter),
        };
    }
    else {
        const partialState = loadFromLS(tableId);
        return {
            top: partialState.top || defaultInitialPageSize || DEFAULT_PAGE_SIZES[0],
            skip: 0,
        };
    }
}
export const callLoaderHelper = async (getState, dispatch, id, silent, loaderFunc) => {
    if (!silent) {
        dispatch(refreshing(id, true));
    }
    try {
        await loaderFunc(extractGetParamsFromState(getState(), id));
    }
    finally {
        if (!silent) {
            dispatch(refreshing(id, false));
        }
    }
};
export const doResetFilters = (id, loaderFunc) => {
    return async (dispatch, getState) => {
        dispatch(resetFilters(id));
        dispatch(changePage(id, 0));
        await callLoaderHelper(getState, dispatch, id, false, loaderFunc);
    };
};
export const doApplyFilters = (id, loaderFunc) => {
    return async (dispatch, getState) => {
        dispatch(applyFilters(id));
        dispatch(changePage(id, 0));
        await callLoaderHelper(getState, dispatch, id, false, loaderFunc);
    };
};
export const doSortColumn = (id, sort, loaderFunc) => {
    return async (dispatch, getState) => {
        const { sortingField, sortingDirection, top, skip, filter } = getState().kptable[id];
        let direction;
        if (sortingField !== sort) {
            direction = SortingDirection.DOWN;
        }
        else {
            switch (sortingDirection) {
                case SortingDirection.DOWN:
                    direction = SortingDirection.UP;
                    break;
                case SortingDirection.UP:
                    direction = SortingDirection.NONE;
                    break;
                default:
                    direction = SortingDirection.DOWN;
            }
        }
        dispatch(refreshing(id, true));
        try {
            if (direction !== SortingDirection.NONE) {
                await loaderFunc({ top, skip, filter: objectToParamFilter(filter), sort, direction });
            }
            else {
                await loaderFunc({ top, skip, filter: objectToParamFilter(filter) });
            }
            return dispatch(sortColumn(id, sort, direction));
        }
        finally {
            dispatch(refreshing(id, false));
        }
    };
};
export const doCallLoaderFunc = (id, loaderFunc, silent = false) => {
    return async (dispatch, getState) => {
        await callLoaderHelper(getState, dispatch, id, silent, loaderFunc);
    };
};
export const doExecuteAction = (id, datum, keyField, action, itemValue) => {
    return async (dispatch) => {
        dispatch(actionConfirmation(id, datum, keyField));
        dispatch(actionWaiting(id, datum[keyField], true));
        try {
            await action.handler(datum, itemValue);
        }
        finally {
            dispatch(actionWaiting(id, datum[keyField], false));
        }
    };
};
export const doExecuteGlobalAction = (id, action, data, keyField) => {
    return async (dispatch, getState) => {
        const { checked, globalCheckedAll, filter, top, skip, sortingField, sortingDirection } = getState().kptable[id];
        const filteredData = data.filter((d) => checked[d[keyField]]);
        dispatch(globalActionWaiting(id, true, action.progress));
        try {
            const progressFunction = action.progress
                ? (progress) => {
                    dispatch(globalActionProgress(id, progress));
                }
                : undefined;
            const queryParams = {
                top,
                skip: skip * top,
                sort: sortingField,
                direction: sortingDirection,
                filter: objectToParamFilter(filter),
            };
            const config = {
                setProgress: progressFunction,
                globalCheckedAll,
                queryParams,
            };
            await action.handler(filteredData, config);
        }
        finally {
            dispatch(globalActionWaiting(id, false));
        }
    };
};
